
import React, { useEffect, useState } from 'react'
import Lightbox from 'react-image-lightbox'
import 'react-image-lightbox/style.css'
import { useDispatch, useSelector } from 'react-redux'
import { anonymousFichierGetItems, selectFichierItems } from '../../../slices/anonymous/anonymousFichierSlice'
import { EnumStatutFichier } from '../../../utils/EnumApp'
import './ImageSlider.css'

//class ImageSlider extends React.Component {

//    constructor(props) {

//        super(props)

//        this.state = {
//            photoIndex: 0,
//            isOpen: false,
//        }

//        // Bind handlers
//        this.getImage = this.getImage.bind(this)
//        this.handleBack = this.handleBack.bind(this)
//        this.handleNext = this.handleNext.bind(this)
//        this.handleClose = this.handleClose.bind(this)
//    }
//    componentDidMount() {

//        // Get files
//        this.props.FichierGetItems(this.props.idFiche, null, EnumStatutFichier.Validee.Value)

//    }
//    getImage(paramIndex) {

//        return this.props.fichierItems[paramIndex].UrlImage
//    }
//    handleBack() {
//        // Lenght
//        let length = (this.props.fichierItems || []).length

//        this.setState({
//            photoIndex: (this.state.photoIndex - 1) % length,
//        })
//    }
//    handleNext() {
//        // Lenght
//        let length = (this.props.fichierItems || []).length

//        this.setState({
//            photoIndex: (this.state.photoIndex + 1) % length,
//        })
//    }
//    handleClose() {
//        // Close
//        if (this.props.onClose != undefined) {
//            this.props.onClose()
//        }
//    }
//    render() {

//        let photoIndex = this.state.photoIndex
//        let count = (this.props.fichierItems || []).length

//        if (count === 0) 
//            return null

//        return (
//            <Lightbox mainSrc={this.getImage(photoIndex)}
//                      nextSrc={this.getImage((photoIndex + 1) % count)}
//                      prevSrc={this.getImage((photoIndex + count - 1) % count)}
//                      onCloseRequest={this.handleClose}
//                      onMovePrevRequest={this.handleBack}
//                      onMoveNextRequest={this.handleNext} />
//        )
//    }
//}

//// Données bindées par redux
//function mapStateToProps(state, props) {
//    return {

//        isLoading: state.fichierData.isLoading,

//        // Fichier
//        fichierItems: state.fichierData.fichierItems

//    }
//}

//// Actions bindées par redux
//function mapDispatchToProps(dispatch) {
//    return bindActionCreators({

//        FichierGetItems: FichierGetItems

//    }, dispatch)
//}

//export default connect(mapStateToProps, mapDispatchToProps)(ImageSlider)





const ImageSlider = ({ idFiche, onClose }) => {

    const dispatch = useDispatch()

    const [photoIndex, setPhotoIndex] = useState(0)
    const [isOpen, setIsOpen] = useState(false)

    const fichierItems = useSelector(selectFichierItems)


    useEffect(() => {

        // Get files
        dispatch(anonymousFichierGetItems({ params: { idFiche } }))

    }, [])

    const getImage = (paramIndex) => {

        return fichierItems[paramIndex].UrlImage
    }
    const handleBack = () => {
        // Lenght
        let length = (fichierItems || []).length

        setPhotoIndex((photoIndex - 1) % length)
    }
    const handleNext = () => {
        // Lenght
        let length = (fichierItems || []).length


        setPhotoIndex((photoIndex + 1) % length)
    }
    const handleClose = () => {
        // Close
        if (onClose != undefined) {
            onClose()
        }
    }

    let count = (fichierItems || []).length

    if (count === 0)
        return null

    return (
        <Lightbox mainSrc={getImage(photoIndex)}
            nextSrc={getImage((photoIndex + 1) % count)}
            prevSrc={getImage((photoIndex + count - 1) % count)}
            onCloseRequest={handleClose}
            onMovePrevRequest={handleBack}
            onMoveNextRequest={handleNext} />
    )
}


export default ImageSlider